import type React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Layout } from '@widgets/consultations';

import {
	AvailablePeriodAddress,
	AvailablePeriodCost,
	AvailablePeriodDate,
	AvailablePeriodDuration,
	AvailablePeriodTime,
	AvailablePeriodType,
	ModeSelector,
	useAssign,
	useAvailablePeriodLoader,
} from '@features/avaialble-periods';
import { ConsultationClient, Row } from '@features/consultations';

import { Card, TextButton } from '@shared/ui';
import { LargeHeader } from '@shared/ui/modals';

import { useAvailablePeriod } from '@src/entities/available-periods';
import { ModalLarge } from '@src/library/components/common';

import * as st from './styles.module.scss';

export const ModalAssign: React.FC = () => {
	const navigate = useNavigate();
	const { code, clientId, availableId } = useParams<{ [x: string]: string }>();
	const id = Number(availableId);
	const clientsId = Number(clientId);

	const onClose = () => navigate(`/clients/${code}/${clientId}/assign`);
	const onAssignSuccess = (id: number) =>
		navigate(`/clients/${code}/${clientId}/assign/consultation/${id}`);

	const { availablePeriod } = useAvailablePeriod(id);
	const { onAssign, mode, onModeChange } = useAssign(id, clientsId, onAssignSuccess);

	const showSelector = availablePeriod && availablePeriod.status.length > 1;

	const showAddress =
		mode === 'OF' ||
		(availablePeriod?.status.length === 1 && availablePeriod?.status.indexOf('OF') !== -1);

	useAvailablePeriodLoader(id);

	return (
		<ModalLarge isOpen disableHeader onRequestClose={onClose}>
			<LargeHeader
				title="Консультация"
				onClose={onClose}
				right={
					<TextButton size="small" onClick={onAssign}>
						Записать
					</TextButton>
				}
			/>
			<Layout
				User={<ConsultationClient id={clientsId} />}
				Consultation={
					<Card className={st.consultation__card}>
						<Row title="Тип" hideBackground={showSelector}>
							{showSelector ? (
								<ModeSelector
									modeList={availablePeriod.status}
									selectedMode={mode}
									changeMode={(e, mode) => onModeChange(mode)}
								/>
							) : (
								<AvailablePeriodType mode={availablePeriod?.status[0] ?? ''} />
							)}
						</Row>
						<Row title="Статус">Запись...</Row>
						<Row title="Дата">
							<AvailablePeriodDate id={id} />
						</Row>
						<Row title="Время">
							<AvailablePeriodTime id={id} />
						</Row>
						<Row title="Длительность">
							<AvailablePeriodDuration id={id} />
						</Row>
						<Row title="Стоимость">
							<AvailablePeriodCost id={id} />
						</Row>

						{showAddress && (
							<Row title="Адрес">
								<AvailablePeriodAddress id={id} />
							</Row>
						)}
					</Card>
				}
			/>
		</ModalLarge>
	);
};
